/* eslint-disable import/no-cycle */
import { call, put, takeEvery } from 'redux-saga/effects';
import { displayLoading, displaySuccess } from '../../utils/toast/Toast';
import { commands } from '../../api/api';
import {
  COMMANDS_REPORT,
  COMMANDS_REPORT_SUCCESS,
  COMMANDS_REPORT_FAILURE
} from './exportCommandsActions';

import logger from '../../utils/logger';

/**
 * Récupération du fichier d'export de commande
 * @param  {object}    action the action object
 */
export function* commandsReport(action) {
  const closeLoading = displayLoading('Préparation de votre fichier en cours');
  try {
    const response = yield call(commands.commandsReport, action.payload);
    if (response.data.success === true) {
      yield put({ type: COMMANDS_REPORT_SUCCESS, payload: response.data });
      window.location.href = response.data.reportUrl;
      closeLoading();
      displaySuccess('Fichier téléchargé avec succès');
    } else {
      closeLoading();
    }
  } catch (error) {
    logger(error);
    yield put({ type: COMMANDS_REPORT_FAILURE });
  }
}

const exportCommandsSaga = [takeEvery(COMMANDS_REPORT, commandsReport)];

export default exportCommandsSaga;
